import React from "react";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", size = "md", iconOnly = false }) {
  const h = size === "sm" ? "h-7" : size === "lg" ? "h-11" : "h-9";
  const inner = iconOnly ? (
    <img src="/coverguide-icon.png" alt="CoverGuide" className={`${h} w-auto`} />
  ) : (
    <img src="/coverguide-primary.png" alt="CoverGuide" className={`${h} w-auto`} />
  );
  if (!to) return <span className={`inline-flex items-center ${className}`}>{inner}</span>;
  return (
    <Link to={to} data-testid="logo-link" className={`inline-flex items-center ${className}`}>
      {inner}
    </Link>
  );
}
